

import { Loading } from '../../../components/Loading'
import Step2Wrapper from '../../../containers/steps/vehicle/Step2/Step2Wrapper'
import { useInsuranceParams } from '../../../context/InsuranceParamsProvider'
import OffersAddonProvider from '../../../context/OffersAddonProvider'
import { OffersVehicleProvider } from '../../../context/OffersVehicleProvider'
import { QuotesProvider } from '../../../context/QuotesContext'
import { SidebarProvider } from '../../../context/SidebarContext'
import { StepsProvider } from '../../../context/StepsContext'
import { WizzardHeaderProvider } from '../../../context/WizzardHeaderContext'

export const Step2Page = () => {
  const { insuranceParams } = useInsuranceParams()

  return (
    <StepsProvider currentStepId={2}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {(!insuranceParams) && <Loading large={true} />}
            {insuranceParams && (
              <OffersVehicleProvider>
                <OffersAddonProvider>
                  <Step2Wrapper />
                </OffersAddonProvider>
              </OffersVehicleProvider>
            )}
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}